// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-r2p7","delete":"styles_delete__12Nst","update":"styles_update__1-wOn","add":"styles_add__2gcjB"};